export default "__VITE_ASSET__CUQe6R5U__"